import { injectable } from "inversify";
import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { SearchOrganisationPresenter } from "@/presenters/SearchOrganisationPresenter";
import { Default } from "./filter-variations/Default";
import DisciplineAreas from "./filter-variations/DisciplineAreas";
import DisciplineCountries from "./filter-variations/DisciplineCountries";
import { Discipline } from "./filter-variations/Discipline";
import AreaAttendanceOnline from "./filter-variations/AreaAttendanceOnline";
import { Areas } from "./filter-variations/Areas";
import CountryAttendanceOnline from "./filter-variations/CountryAttendanceOnline";
import Countries from "./filter-variations/Countries";
import { University } from "./filter-variations/University";
import { Attendance } from "./filter-variations/Attendance";
import { FilterOptions } from "@/filters/options/FilterOptions";
import { SeoHeadingHandler } from "./SeoHeadingHandler";
import { Continents } from "./filter-variations/Continents";
import { SortingState } from "@/sorting/SortingState"
import { Area as AreaRanked } from "./filter-variations/sorting/Area";
import { AreaAttendanceOnline as AreaAttendanceOnlineRanked } from "./filter-variations/sorting/AreaAttendanceOnline";
import { Attendance as AttendanceRanked } from "./filter-variations/sorting/Attendance";
import { AttendanceOnline as AttendanceOnlineRanked } from "./filter-variations/sorting/AttendanceOnline";
import { Continent as ContinentRanked } from "./filter-variations/sorting/Continent";
import { Country as CountryRanked } from "./filter-variations/sorting/Country";
import { CountryAttendanceOnline as CountryAttendanceOnlineRanked } from "./filter-variations/sorting/CountryAttendanceOnline";
import { Discipline as DisciplineRanked } from "./filter-variations/sorting/Discipline";
import { DisciplineCountry as DisciplineCountryRanked } from "./filter-variations/sorting/DisciplineCountry";
import { Unfiltered as UnfilteredRanked } from "./filter-variations/sorting/Unfiltered";
import { University as UniversityRanked } from "./filter-variations/sorting/University";


@injectable()
export class SeoHeadingFilterVariations extends SeoHeadingHandler {
	private readonly handler: SeoHeadingHandler;

	public constructor(filterOptions: FilterOptions, organisationPresenter: SearchOrganisationPresenter) {
		super(filterOptions);

		this.handler = new University(filterOptions, organisationPresenter);
		this.handler
			.setNext(new DisciplineAreas(filterOptions))
			.setNext(new DisciplineCountries(filterOptions))
			.setNext(new Discipline(filterOptions))
			.setNext(new AreaAttendanceOnline(filterOptions))
			.setNext(new Areas(filterOptions))
			.setNext(new CountryAttendanceOnline(filterOptions))
			.setNext(new Countries(filterOptions))
			.setNext(new Continents(filterOptions))
			.setNext(new Attendance(filterOptions))
			.setNext(new UniversityRanked(filterOptions, organisationPresenter))
			.setNext(new AreaAttendanceOnlineRanked(filterOptions))
			.setNext(new CountryAttendanceOnlineRanked(filterOptions))
			.setNext(new DisciplineCountryRanked(filterOptions))
			.setNext(new AreaRanked(filterOptions))
			.setNext(new CountryRanked(filterOptions))
			.setNext(new ContinentRanked(filterOptions))
			.setNext(new DisciplineRanked(filterOptions))
			.setNext(new AttendanceOnlineRanked(filterOptions))
			.setNext(new AttendanceRanked(filterOptions))
			.setNext(new UnfilteredRanked(filterOptions))
			.setNext(new Default(filterOptions));
	}

	public override async handle(filterSelectionState: FilterSelectionState, sortState: SortingState): Promise<string> {
		return await this.handler.handle(filterSelectionState, sortState);
	}

	public override async canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean> {
		return await this.handler.canHandle(sortState, filterSelectionState);
	}

	protected override async selfHandle(filterSelectionState: FilterSelectionState, sortState: SortingState): Promise<string> {
		return await this.handler.handle(filterSelectionState, sortState);
	}
}
